import React, { useState } from 'react';
import { Smartphone, Bell } from './Icons';
import NotificationPanel from './NotificationPanel';

const Header = ({
  title,
  onEnterMobilePreview,
  notifications = [],
  onMarkAsRead,
  onMarkAllAsRead,
  onNavigate,
  todoCount = 0
}) => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <header className="bg-white border-b border-slate-200 h-16 flex items-center justify-between px-8 sticky top-0 z-10">
      <h2 className="text-xl font-bold text-slate-800">{title}</h2>
      <div className="flex items-center gap-4">
        {onEnterMobilePreview && (
          <button
            onClick={onEnterMobilePreview}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-slate-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            title="预览移动端"
          >
            <Smartphone size={18} />
            <span>移动端预览</span>
          </button>
        )}

        {/* 待办角标 */}
        {todoCount > 0 && (
          <div
            className="flex items-center gap-1 px-3 py-1 bg-orange-50 rounded-full cursor-pointer hover:bg-orange-100 transition-colors"
            onClick={() => onNavigate && onNavigate('approval')}
          >
            <span className="text-xs text-orange-600 font-medium">
              待办 {todoCount}
            </span>
          </div>
        )}

        {/* 通知铃铛 */}
        <div className="relative">
          <button
            onClick={() => setIsNotificationOpen(!isNotificationOpen)}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
          >
            <Bell size={20} className="text-slate-400 hover:text-slate-600" />
            {unreadCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 text-white text-xs rounded-full flex items-center justify-center px-1">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </button>

          <NotificationPanel
            notifications={notifications}
            isOpen={isNotificationOpen}
            onClose={() => setIsNotificationOpen(false)}
            onMarkAsRead={onMarkAsRead}
            onMarkAllAsRead={onMarkAllAsRead}
            onNavigate={onNavigate}
          />
        </div>

        <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-sm font-bold text-slate-600">
          赵
        </div>
      </div>
    </header>
  );
};

export default Header;
